import { Injectable } from "@angular/core";
import { RxStomp } from "@stomp/rx-stomp";


@Injectable({
    providedIn: 'root'
})
export class RxStompClient extends RxStomp {
    /**
     *
     */
    constructor() {
        super();

    }
}


import { Observable, Observer } from 'rxjs';
import { AnonymousSubject } from 'rxjs/internal/Subject';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthenticationService } from "./authentication.service";

const CHAT_URL = "ws://127.0.0.1:8080/websocket/tracker";

export interface Message {
    source: string;
    content: string;
}

@Injectable()
export class WebsocketService {
    private subject: AnonymousSubject<MessageEvent>;
    public messages: Subject<Message>;

    constructor(authService: AuthenticationService) {
        const authToken = authService.getCurrentJwt();
        this.messages = <Subject<Message>>this.connect(CHAT_URL + '?access_token=' + authToken).pipe(
            map(
                (response: MessageEvent): Message => {
                    let data = JSON.parse(response.data)
                    return data;
                }
            )
        );
    }

    public connect(url): AnonymousSubject<MessageEvent> {
        if (!this.subject) {
            this.subject = this.create(url);
            console.log("Successfully connected: " + url);
        }
        return this.subject;
    }

    private create(url): AnonymousSubject<MessageEvent> {
        let ws = new WebSocket(url);
        let observable = new Observable((obs: Observer<MessageEvent>) => {
            ws.onmessage = obs.next.bind(obs);
            ws.onerror = obs.error.bind(obs);
            ws.onclose = obs.complete.bind(obs);
            return ws.close.bind(ws);
        });
        let observer = {
            error: null,
            complete: null,
            next: (data: Object) => {
                console.log('Message sent to websocket: ', data);
                if (ws.readyState === WebSocket.OPEN) {
                    ws.send(JSON.stringify(data));
                }
            }
        };
        return new AnonymousSubject<MessageEvent>(observer, observable);
    }
}
